<template>
<div class="main-container">
    <createGifModal v-if="creationModalShown" @hideModal="hideCreationModal" />
    <pageHeader createBtn @showModal="showModal" />

    <div class="single-card-cont">
        <loadingSkeleton v-if="!postId" />
        <gifCard v-if="postExist"
            :postId = "postId"
            @doesntExist="postDoesntExist"
        />
        <div class="wrong-url-msg" v-if="!postExist">
            <h2>⚠️</h2>
            <h2>Oops!</h2>
            <p>
                Gif is either deleted or the link you followed is wrong.
                You will be redirected to the home page in {{counter}} seconds
            </p>
        </div>
        
    </div>
    <router-link
        to="/"
        class="back-to-home-link">
        Back to Home Page
    </router-link>
    
</div>
</template>

<script>

import pageHeader from '@/components/pageHeader'
import createGifModal from '@/components/createGifModal'
import gifCard from '@/components/gifCard'
import loadingSkeleton from '@/components/loadingSkeleton'

export default {
    name: 'Post',
    components: {
        pageHeader,
        createGifModal,
        gifCard,
        loadingSkeleton,
    },
    data() {
        return {
            postId: this.$route.params.id,
            post: null,
            creationModalShown: false,
            postExist: true,
            loadingSkeletonShown: true,
            counter: 5, // count down counter before redirecting to home if url is wrong
        }
    },
    methods: {
      showModal() {
          this.creationModalShown = true;
      },
      hideCreationModal() {
          this.creationModalShown = false;
      },
      checkID() {
          if (!this.postId) {
              this.postId = "No ID passed";
              return false;
          } else {
              return true;
          }
      },
      redirectToHome() {
          this.$router.push({ name: 'Home'});
      },
      postDoesntExist() {
          this.postExist = false;
          this.countDown(this.counter, this.redirectToHome);
      },
      countDown(number, callback) {
          this.counter = number;        
          let that = this;
          let intervalFun = window.setInterval(function() {
              if (that.counter > 1) {
                  that.counter -= 1;
              } else {
                  clearInterval(intervalFun);
                  callback();
              }
          }, 1000);
      },    
    },
    mounted() {
      // Check if there's an ID passed to the page
      // "url/post/id" and fetch database
      if (!this.checkID()){
        this.redirectToHome();
      }
    }
}
</script>

<style>

</style>